import { inject, Injectable } from '@angular/core';
import { ClusterService, OrganisationLanguage } from '../core/cluster.service';


@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private cluster = inject(ClusterService);

  constructor(

  ) {
  }

  getAvailableLanguages() {
    const org = this.cluster.getCurrentOrganisation();
    if (org === undefined) {
      return [];
    }

    const organisationLanguages = org.availableLanguages;

    if (organisationLanguages === null) {
      return [];
    }

    return organisationLanguages;
  }

  getOriginalLanguage(): OrganisationLanguage | undefined {
    const org = this.cluster.getCurrentOrganisation();
    if (org === undefined || org === null) {
      return undefined;
    }

    const organisationLanguages = org.availableLanguages;

    if (organisationLanguages === null) {
      return undefined;
    }

    const lang = organisationLanguages.find(orgLang => orgLang.is_default === true);
    if (lang === undefined) {
      return undefined;
    }
    return lang;
  }

  getOriginalLanguageCode(): string | undefined {
    const language = this.getOriginalLanguage();
    if (language === undefined) {
      return undefined;
    }
    return language['language_code'];
  };

  getTranslationLanguages() {
    const org = this.cluster.getCurrentOrganisation();
    if (org === undefined) {
      return [];
    }

    const organisationLanguages = org.availableLanguages;

    if (organisationLanguages === null) {
      return [];
    }

    return organisationLanguages.filter(orgLang => orgLang.is_default !== true);
  }

  getTranslationLanguageCodes() {
    return this.getTranslationLanguages().map(orgLang => orgLang['language_code']);
  }

  getTranslationLanguage(languageCode: string) {
    const org = this.cluster.getCurrentOrganisation();
    if (org === undefined) {
      return undefined;
    }

    const organisationLanguages = org.availableLanguages;

    if (organisationLanguages === null) {
      return undefined;
    }

    return organisationLanguages.find(orgLang => orgLang['language_code'] === languageCode);
  }
}
